<template>
  <div 
    
    class="dropdown col-12 col-lg-4" 
    :class="{ 'custom-margin': margin }"
    @focus="handleFocus"
    @focusout="handleFocusOut"
    @keydown.esc="handleFocusOut"
    tabindex="0"
  >
    <!-- Zone d'affichage -->
    <div style="height: 54px" class="select d-flex justify-content-between align-items-center text-white" @click="open_menu">
      <span class="selected me-2">{{ display }}</span>
      <div class="caret" :class="openMenu ? 'caret-rotate' : ''"></div>
    </div>

    <ul class="menu" :class="openMenu ? 'menu-open opacity-100 d-block mb-0' : ''">
  <!-- Onglets -->
  <div class="container-mode d-flex w-100 mb-2">
    <div
      v-if="data"
      class="mode-button d-flex justify-content-center w-100"
      @click="tabSelected = 'risk'"
      :class="{ selectmode: tabSelected === 'risk' }"
    >
      <label class="spacing-mode">Risk</label>
    </div>
    <div
      v-if="dataOpport"
      class="mode-button d-flex justify-content-center w-100"
      @click="tabSelected = 'opport'"
      :class="{ selectmode: tabSelected === 'opport' }"
    >
      <label class="spacing-mode">Opportunity</label>
    </div>
  </div>


      <!-- Arborescence - Contenu dynamique basé sur tabSelected -->
      <div v-if="menuItems && menuItems.length > 0">
        <ul class="first-label ps-0">
          <li v-for="(lvl1item, lvl1index) in menuItems" :key="lvl1index">
            <div class="searchInd d-flex justify-content-between align-items-center">
              <div class="label-container">
                <label class="first d-inline-block py-1" @click="new_selected(lvl1item.label, lvl1item.id)">
                  {{ lvl1item.label }}
                </label>
              </div>
              <div>
                <label class="span-right" :for="lvl1item.id" v-if="lvl1item.id !== 'overallcountryrisk'">
                  <span class="material-icons" v-if="lvl1item.submenu?.length">
                    arrow_drop_down
                  </span>
                </label>
              </div>
            </div>
            <input type="checkbox" :id="lvl1item.id">
            <ul class="lvl2menu p-0 pb-2 ms-2" v-if="lvl1item.submenu?.length">
              <li v-for="(lvl2item, lvl2index) in lvl1item.submenu" :key="lvl2index">
                <div class="searchInd d-flex justify-content-between align-items-center">
                  <div class="label-container">
                    <label class="second p-1 d-inline-block" @click="new_selected(lvl2item.label, lvl2item.id)">
                      {{ lvl2item.label }}
                    </label>
                  </div>
                  <div class="p-1">
                    <label class="span-right" :for="lvl2item.id">
                      <span class="material-icons" v-if="lvl2item.submenu?.length">
                        arrow_drop_down
                      </span>
                    </label>
                  </div>
                </div>
                <input type="checkbox" :id="lvl2item.id">
                <ul class="lvl3menu p-0 pb-2 mx-2" v-if="lvl2item.submenu?.length">
                  <li v-for="(lvl3item, lvl3index) in lvl2item.submenu" :key="lvl3index">
                    <div class="searchInd d-flex justify-content-between align-items-center">
                      <div class="label-container">
                        <label class="second p-1 d-inline-block" @click="new_selected(lvl3item.label, lvl3item.id)">
                          {{ lvl3item.label }}
                        </label>
                      </div>
                      <div class="p-1">
                        <label class="span-right" :for="lvl3item.id">
                          <span class="material-icons" v-if="lvl3item.submenu?.length">
                            arrow_drop_down
                          </span>
                        </label>
                      </div>
                    </div>
                    <input type="checkbox" :id="lvl3item.id">
                    <ul class="lvl4menu p-0 mx-2" v-if="lvl3item.submenu?.length">
                      <li v-for="(lvl4item, lvl4index) in lvl3item.submenu" :key="lvl4index">
                        <div class="searchInd d-flex justify-content-between align-items-center">
                          <div class="label-container">
                            <label class="second" @click="new_selected(lvl4item.label, lvl4item.id)">
                              {{ lvl4item.label }}
                            </label>
                          </div>
                          <div class="p-1">
                            <label class="span-right" :for="lvl4item.id">
                              <span class="material-icons" v-if="lvl4item.submenu?.length">
                                arrow_drop_down
                              </span>
                            </label>
                          </div>
                        </div>
                        <input type="checkbox" :id="lvl4item.id">
                        <ul class="lvl5menu p-0 mx-2" v-if="lvl4item.submenu?.length">
                          <li v-for="(lvl5item, lvl5index) in lvl4item.submenu" :key="lvl5index">
                            <div class="searchInd d-flex justify-content-between align-items-center">
                              <div class="label-container">
                                <label class="second" @click="new_selected(lvl5item.label, lvl5item.id)">
                                  {{ lvl5item.label }}
                                </label>
                              </div>
                              <div class="p-1">
                                <label class="span-right" :for="lvl5item.id"></label>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </ul>
  </div>
</template>



<script>


/* eslint-disable */
import api from '@/services/api'
import IndicatorName from '@/views/app.json'
import IndicatorOpportName from '@/views/app_opport.json'

export default {
  emits: ['submit'],
  props: {
    title: {
      type: String,
      required: false,
    },
    queryTitle: {
      type: String,
      required: false,
    },
    path: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    dataOpport: {
      type: Object,
      required: true,
    },
    titleV: {
      type: String,
      required: false,
    },
    push: {
      type: Boolean,
      required: false,
    },
    margin: {
      type: Boolean,
      required: false,
    },
    defaultIndicator: {
      type: String,
      required: false
    }
  },
  data () {
        return {
            openMenu: false,
            selectedEle: '',
            display: '',
            tabSelected: localStorage.getItem('tabSelected') || 'risk',
            searchTerm: '',
            filteredCountries: this.data,
            inputStrings: [],
            menuItems: [],
            RenameItem: {specificNames: {}},
          }
        },
        methods : {

        handleFocus() {
        },
        handleFocusOut() {
            this.openMenu = false
        },
        open_menu() {
            this.openMenu = !this.openMenu
        },
        new_selected(label, id) {
          this.display = label
          this.$emit('submit', id)
            this.open_menu()
            if (this.push) {
              this.$router.push(`/${this.path}/${id}`).then(() => {
                localStorage.setItem('selectedEle', label);
                window.location.reload()
              });
            } else {
              this.$emit('getIndicatorFromDropDown', id);
            }
            localStorage.setItem('selectedEle', label);

            

            this.selectedEle = label
        },
        filterCountries() {
          if (this.searchTerm.trim() === '') {
            this.filteredCountries = this.data;
          } else {
            this.filteredCountries = this.data.filter((item) =>
            item[0].toLowerCase().includes(this.searchTerm.toLowerCase())
          );
        }
      },
    buildRenameItem(obj, path) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key];
          const newPath = path ? `${path}/${key}` : key;
          if (item && item.code && item.code.indexOf('/') === -1) {
            this.RenameItem[item.code] = { label: item.description, value: item.value, rank : item.rank };
          } else {
            this.RenameItem.specificNames[item.code] = { label: item.description, value: item.value, rank : item.rank };
          }
          if (typeof item === 'object' && !Array.isArray(item)) {
            this.buildRenameItem(item, newPath);
          }
        }
      }
    },
    getDataFromCsv() {
      if( this.tabSelected === 'risk') {
        for (const key in this.data) {
          if (this.data.hasOwnProperty(key)) {
            const item = this.data[key];
            this.inputStrings.push(item.code);
          }
        }
        this.buildRenameItem(this.data, '');
      } else {
        for (const key in this.dataOpport) {
          if (this.dataOpport.hasOwnProperty(key)) {
            const item = this.dataOpport[key];
            this.inputStrings.push(item.code);
          }
        }
        this.buildRenameItem(this.dataOpport, '');
      }
    },
    async getSsindLab() {
      try {
        // Choisir les bonnes données en fonction de l'onglet sélectionné
        const sourceData = this.tabSelected === 'risk' ? this.data : this.dataOpport;


        // Réinitialiser les données de menu et autres variables
        this.inputStrings = [];
        this.menuItems = [];
        this.RenameItem = { specificNames: {} };
        // Charger les données de base
        for (const key in sourceData) {
          if (sourceData.hasOwnProperty(key)) {
            const item = sourceData[key];
            this.inputStrings.push(item.code);
          }
        }
        this.buildRenameItem(sourceData, '');
        // Générer le menu à partir des données
        this.inputStrings.forEach(inputString => {
          this.generateMenu(inputString);
        });
        // Renommer les éléments dans le menu en fonction des données
        this.RenameInput(this.menuItems);
        // Mettre à jour le label depuis l'ID
        const updateLabelFromId = (items) => {
          for (const item of items) {
            if (item.id === this.selectedEle) {
              this.selectedEle = item.label;
              return true;
            }
            if (item.submenu && updateLabelFromId(item.submenu)) {
              return true;
            }
          }
          return false;
        };
        updateLabelFromId(this.menuItems)
        // Émettre l'événement pour indiquer le nom de l'élément sélectionné
        this.emitIndicatorName();
      } catch (error) {
        console.error('Erreur lors de la récupération des Indicateurs :', error);
      }
    },
    generateMenu(inputString) {
      const levels = inputString.split('/');
      let currentLevel = this.menuItems;

      levels.forEach((level) => {
        let existingItem = currentLevel.find(item => item.label === level);

        if (!existingItem) {
          const menuItem = {
            id: level,
            label: level,
            submenu: [],
            value: 0,
            rank: 0,
          };
          currentLevel.push(menuItem);
          currentLevel = menuItem.submenu;
        } else {
          currentLevel = existingItem.submenu;
        }
      });
    },
    RenameInput(tab) {
      this.recursiveRename(tab)
  },
  recursiveRename(submenu, parentLabel = null) {
    submenu.forEach((item) => {
      const itemLabel = item.label;
      const combinedLabel = parentLabel ? parentLabel + "/" + itemLabel : itemLabel;

      if (this.RenameItem.specificNames[combinedLabel] && this.RenameItem.specificNames[combinedLabel].label) {
        item.label = this.RenameItem.specificNames[combinedLabel].label;
        item.value = this.RenameItem.specificNames[combinedLabel].value;
        item.rank = this.RenameItem.specificNames[combinedLabel].rank;
      } else if (parentLabel && this.RenameItem.specificNames[parentLabel] && this.RenameItem.specificNames[parentLabel].label) {
        item.label = this.RenameItem.specificNames[parentLabel].label;
        item.value = this.RenameItem.specificNames[parentLabel].value;
        item.rank = this.RenameItem.specificNames[parentLabel].rank;
      } else if (this.RenameItem[itemLabel] && this.RenameItem[itemLabel].label) {
        item.label = this.RenameItem[itemLabel].label;
        item.value = this.RenameItem[itemLabel].value;
        item.rank = this.RenameItem[itemLabel].rank;
      }

      if (item.submenu && item.submenu.length > 0) {
        this.recursiveRename(item.submenu, combinedLabel);
      }
    });
  },
  emitIndicatorName() {
        const data = this.selectedEle
        if (this.tabSelected === 'risk') {
          this.$emit("indicatorName", data)
          this.$emit("indicatorType", 'risk');
        } else {
          this.$emit("indicatorNameOpport", data)
          this.$emit("indicatorType", 'opport');
        }
    }
  },
    watch: {
    searchTerm() {
      this.filterCountries();
    },
    tabSelected(newVal) {
      localStorage.setItem('tabSelected', newVal);
      this.getSsindLab();
      this.getDataFromCsv();
    }
  },
    mounted() {
      if(!this.data){
        this.tabSelected = "opport"
      } else {
        this.tabSelected = "risk"
      }
      if(this.defaultIndicator){
        this.selectedEle = this.defaultIndicator
      }
      else if (!this.$route.params.element && !this.$route.params.indicator) {
        this.selectedEle = this.title
      } else if (this.$route.params.indicator) {
        this.selectedEle = this.$route.params.indicator
        
      } else {
        this.selectedEle = this.$route.params.element
      }

        for(let i = 0; i < IndicatorName.length; i++){
          if(IndicatorName[i].code.split("/")[IndicatorName[i].code.split("/").length-1] == this.selectedEle){
            this.display = IndicatorName[i].description
          }
        }
        for(let i = 0; i < IndicatorOpportName.length; i++){
          if(IndicatorOpportName[i].code.split("/")[IndicatorOpportName[i].code.split("/").length-1] == this.selectedEle){
            this.display = IndicatorOpportName[i].description
          }
        }
        this.getSsindLab()
        this.getDataFromCsv()
      }
      
  }
</script>

